export const tenureOptions = [
  { label: '1' }, { label: '2' }, { label: '3' }, { label: '4' }, { label: '5' }, { label: '6' }, { label: '7' }, { label: '8' }, { label: '9' }, { label: '10' },
  { label: '11' }, { label: '12' }, { label: '13' }, { label: '14' }, { label: '15' }, { label: '16' }, { label: '17' }, { label: '18' }, { label: '19' }, { label: '20' },
  { label: '21' }, { label: '22' }, { label: '23' }, { label: '24' }, { label: '30' }, { label: '36' }, { label: '48' },
]

export const tenureYearMonthOptions = [
  { label: '0' }, { label: '1' }, { label: '2' }, { label: '3' }, { label: '4' }, { label: '5' }, { label: '6' }, { label: '7' }, { label: '8' }, { label: '9' }, { label: '10' },
  { label: '11' }, { label: '12' }
]


export const productCategoryOptions = [
  { label: 'Subvention GST' }, { label: 'Subvention Non GST' }, { label: 'Standard EMI' }, { label: 'B2B' }, { label: 'Hybrid' }
];


export const productTenureOptions = [
  { label: '1' }, { label: '2' }, { label: '3' }, { label: '4' }, { label: '5' }, { label: '6' },
  { label: '7' }, { label: '8' }, { label: '9' }, { label: '10' }, { label: '11' }, { label: '12' },
  { label: '13' }, { label: '14' }, { label: '15' }, { label: '16' }, { label: '17' }, { label: '18' },
  { label: '19' }, { label: '20' }, { label: '21' }, { label: '22' }, { label: '23' }, { label: '24' },
  { label: '25' }, { label: '26' }, { label: '27' }, { label: '28' }, { label: '29' }, { label: '30' },
  { label: '31' }, { label: '32' }, { label: '33' }, { label: '34' }, { label: '35' }, { label: '36' }
];


export const advanceEmiOptions = [
  { label: '0' }, { label: '1' }, { label: '2' }, { label: '3' }, { label: '4' }, { label: '5' }, { label: '6' },
  { label: '7' }, { label: '8' }, { label: '9' }, { label: '10' }, { label: '11' }, { label: '12' },
];

export const pfTypeOptions = [
  { label: 'Flat' }, { label: 'Percentage' }, { label: 'Varied' },
];

export const subVerticals = {
  2: {
    New: 1,
    Old: 2
  },
  3: {
    New: 1,
    Old: 2
  }
}

export const propertyTypeOptions = [
  { label: 'Residential Property' },
  { label: 'Commercial Property' },
  { label: 'Industrial Property' },
  { label: 'Warehouse Property' },
]

export const vehicleTypeOptions = [
  { label: '2 Wheeler - New' },
  { label: '2 Wheeler - Used' },
  { label: '4 Wheeler - New' },
  { label: '4 Wheeler - Used' },
  { label: 'CE - construction equipment' },
  { label: 'LCV - light commercial vehicle' },
  { label: 'HCV - heavy commercial vehicle' },

]

export const relationOptions = [
  { label: 'Spouse' },
  { label: 'Parent' },
  { label: 'Guardian' },
  { label: 'Friend' },
]

export const businessTypeEntityTypes = [
  { label: "Proprietorship Firm" },
  { label: "Partnership Firm" },
  { label: "Limited Liability Partnership" },
  { label: "Private Limited Company" },
  { label: "Public Limited Company" },
  { label: "One Person Company" },
];


export const turnoverRanges = [
  { value: 'less_than_5L', label: 'Less than ₹5L', lowerLimit: 0, upperLimit: 500000 },
  { value: '5L_10L', label: '₹5L - ₹10L', lowerLimit: 500000, upperLimit: 1000000 },
  { value: '10L_20L', label: '₹10L - ₹20L', lowerLimit: 1000000, upperLimit: 2000000 },
  { value: '20L_30L', label: '₹20L - ₹30L', lowerLimit: 2000000, upperLimit: 3000000 },
  { value: 'above_30L', label: 'Above ₹30L', lowerLimit: 3000000, upperLimit: null },
];

export const statesList = [
  { label: "ANDAMAN AND NICOBAR ISLANDS" },
  { label: "ANDHRA PRADESH" },
  { label: "ARUNACHAL PRADESH" },
  { label: "ASSAM" },
  { label: "BIHAR" },
  { label: "CHANDIGARH" },
  { label: "CHATTISGARH" },
  { label: "DAMAN & DIU" },
  { label: "DADRA & NAGAR HAVELI" },
  { label: "DELHI" },
  { label: "GOA" },
  { label: "GUJARAT" },
  { label: "HARYANA" },
  { label: "HIMACHAL PRADESH" },
  { label: "JAMMU & KASHMIR" },
  { label: "JHARKHAND" },
  { label: "KARNATAKA" },
  { label: "KERALA" },
  { label: "LADAKH" },
  { label: "LAKSHADWEEP" },
  { label: "MANIPUR" },
  { label: "MAHARASHTRA" },
  { label: "MEGHALAYA" },
  { label: "MIZORAM" },
  { label: "MADHYA PRADESH" },
  { label: "NAGALAND" },
  { label: "ORISSA" },
  { label: "PONDICHERRY" },
  { label: "PUNJAB" },
  { label: "RAJASTHAN" },
  { label: "SIKKIM" },
  { label: "TAMIL NADU" },
  { label: "TELANGANA" },
  { label: "TRIPURA" },
  { label: "UTTAR PRADESH" },
  { label: "UTTARANCHAL" },
  { label: "WEST BENGAL" },
  { label: "APO Address" },
]

export const PersonalLoanPurpose = [
  { label: "MedicalExpenses", value: 1 },
  { label: "HouseholdExpenses", value: 2 },
  { label: "WeddingExpenses", value: 3 },
  { label: "Education", value: 4 },
  { label: "Shopping", value: 5 },
  { label: "Vacation", value: 6 },
  { label: "PersonalReason", value: 7 },
  { label: "VehiclePurchase", value: 8 }

]

export const policyDetails = [
  {
    status: 'In Submission',
    policies: [
      { label: 'Age must 18 above', details: ['Applicant age should be above 18', 'Age is taken from the PAN verification'] },
      { label: 'Policy 2', details: ['Applicant age should be above 18', 'Age is taken from the PAN verification'] },
    ]
  },
  {
    status: 'In Sanction',
    policies: [
      { label: 'Policy 1', details: ['Applicant age should be above 18', 'Age is taken from the PAN verification'] },
      { label: 'Policy 2', details: ['Applicant age should be above 18', 'Age is taken from the PAN verification'] },

    ]
  },
  {
    status: 'Rejected',
    policies: [
      { label: 'Policy 1', details: ['Applicant age should be above 18', 'Age is taken from the PAN verification'] },
      { label: 'Policy 2', details: ['Applicant age should be above 18', 'Age is taken from the PAN verification'] },

    ]
  },
  {
    status: 'Disbursed',
    policies: [
      { label: 'Policy 1', details: ['Applicant age should be above 18', 'Age is taken from the PAN verification'] },
    ]
  }
]


export const businessLoanTenureMonthOptions = [
  { label: '3', value: 3 }, { label: '4', value: 4 }, { label: '5', value: 5 }, { label: '6', value: 6 },
  { label: '7', value: 7 }, { label: '8', value: 8 }, { label: '9', value: 9 }, { label: '10', value: 10 },
  { label: '11', value: 11 }, { label: '12', value: 12 }, { label: '13', value: 13 }, { label: '14', value: 14 },
  { label: '15', value: 15 }, { label: '16', value: 16 }, { label: '17', value: 17 }, { label: '18', value: 18 },
  { label: '19', value: 19 }, { label: '20', value: 20 }, { label: '21', value: 21 }, { label: '22', value: 22 },
  { label: '23', value: 23 }, { label: '24', value: 24 },
];

export const ApplicationStatusEnum = {
    InSubmission: 'In Submission',
    InReview: 'In Review',
    InReviewAgain: 'In Review Again',
    InProcess: 'In Process',
    InSanction: 'In Sanction',
    InDisbursement: 'In Disbursement',
    Disbursed: 'Disbursed',
    Rejected: 'Rejected',
    Dropped: 'Dropped',
    OnHold:'On Hold',
    ReadyToDisburse:'Ready to Disburse',
    PendingDisbursement:"Pending Disbursement"
};

export const states = [
  "Select State",
  "JAMMU & KASHMIR",
  "HIMACHAL PRADESH",
  "PUNJAB",
  "CHANDIGARH",
  "UTTARANCHAL",
  "HARYANA",
  "DELHI",
  "RAJASTHAN",
  "UTTAR PRADESH",
  "BIHAR",
  "SIKKIM",
  "ARUNACHAL PRADESH",
  "NAGALAND",
  "MANIPUR",
  "MIZORAM",
  "TRIPURA",
  "MEGHALAYA",
  "ASSAM",
  "WEST BENGAL",
  "JHARKHAND",
  "ORISSA",
  "CHATTISGARH",
  "MADHYA PRADESH",
  "GUJARAT",
  "DAMAN & DIU",
  "DADRA & NAGAR HAVELI",
  "MAHARASHTRA",
  "ANDHRA PRADESH",
  "KARNATAKA",
  "GOA",
  "LAKSHADWEEP",
  "KERALA",
  "TAMIL NADU",
  "PONDICHERRY",
  "ANDAMAN AND NICOBAR ISLANDS",
  "TELANGANA",
  "LADAKH",
  "APO Address",
]

export const UserType = {
  Admin: "admin",
  LoanProcessor: "cra",
  User: "user",
  InstituteUser: "institute_user",
  CoLender: "co_lender",
  Finance: "finance",
  Collection: "collection",
  InstituteAdmin: "institute_admin",
  ChannelUser:'channel_user',
  Executive:'exec'
};